<template>
  <div class="" id="header" ref="header">
    <div class="radious-sec">
      <div class="header-ds">
        <div class="section-title-wrap">
          <h4 :style="fontSizeStyle">{{surveyMasterDetails.st_survey_name}}</h4>
        </div>
      </div>
      <div class="draft-sec">
          <h5>Edit Form</h5>
      </div>
    </div>
    <div class="logo-sec" v-if="surveyDesignDetails && surveyDesignDetails.logoUrl">
      <div :class="[surveyDesignDetails.logo_align == 0 ? 'text-left' : surveyDesignDetails.logo_align == 1 ? 'text-center' : 'text-right']">
        <div class="logo-bar-wrapper">
          <a href="#">
            <img :src="surveyDesignDetails.logoUrl" alt="logo">
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import VueCircle from "vue2-circle-progress";
var { frontHostName } = require("../../../config/config.js");
export default {
  name: "Header",
  components: {
    VueCircle
  },
  props: ["ifShownDisplay"],
  computed: {
    ...mapGetters("previewSurvey", [
      "surveyMasterDetails",
      "surveyDesignDetails"
    ])
  },
  data() {
    return {
      fontSizeStyle: {},
      totalPercentageCompleted: 0,
      totalRequiredQues: 0,
      fill: { color: "#3bb54a" }
    };
  },
  mounted() {
  },
  created() {
    if (this.surveyMasterDetails.st_survey_name) {
      this.totalRequiredQues = this.surveyMasterDetails.in_total_required_ques;
      if (
        this.surveyMasterDetails.st_survey_name.length > 62 &&
        this.surveyMasterDetails.st_survey_name.length < 121
      ) {
        this.fontSizeStyle = { fontSize: "24px", wordBreak: "break-all" };
      } else if (this.surveyMasterDetails.st_survey_name.length > 121) {
        this.fontSizeStyle = { fontSize: "18px", wordBreak: "break-all" };
      }
    }
  },
  methods: {
    hispec() {
      var parts = window.location.href.split(".");
      let whitelabel = this.$session.get("whitelabel");
      var loc =
        frontHostName +
        process.env.CAKE_BASE_PATH +
        whitelabel +
        process.env.CAKE_SURVEY_PATH;
      // var loc = "http://" + location.hostname + process.env.CAKE_SURVEY_PATH;
      window.location.href = loc;
    },
  }
};
</script>



// WEBPACK FOOTER //
// src/components/EditResponse/Header.vue